import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";
import { RequestConstant } from "./RequestConstant";

const initialState = {
  RequestVehicleDataList: [],
  RequestVehicleDataloading: {
    isLoading: false,
  },


};

export const RequestDataReducer = persistReducer(
  {
    storage,
    key: "RequestVehicleData",
    whitelist: ["RequestVehicleDataList"],
  },

  (state = initialState, { type, payload }) => {
    switch (type) {
      case RequestConstant.REQUEST_VEHICLE_REQUEST: {
        return {
          ...state,
          RequestVehicleDataList: [],
          RequestVehicleDataloading: {
            isLoading: true,
          },
        };
      }

      case RequestConstant.REQUEST_VEHICLE_RESPONSE: {
        return {
          ...state,
          RequestVehicleDataList: payload,
          RequestVehicleDataloading: {
            isLoading: false,
          },
        };
      }

      default:
        return state;
    }
  }
);
